export { durationStep, durations } from '../utils/durations';
export { exitingDurations } from '../utils/exiting-durations';

export type { Durations } from '../utils/durations';
